import { Button } from '@fly/core';
import { useOverflowExpand } from '@fly/shared-hooks';
import cn from 'classnames';

export function FlyMultiLineOverflowText({
  text,
  className,
  maxLines = 2,
  expandedMaxLines,
}: {
  text: string;
  className?: string;
  maxLines?: number;
  expandedMaxLines?: number;
}) {
  const { ref, isOverflowing, isExpanded, toggleExpanded } =
    useOverflowExpand(text);

  return (
    <div>
      <span
        ref={ref}
        style={{
          WebkitLineClamp: isExpanded ? expandedMaxLines : maxLines,
        }}
        className={cn(
          isExpanded && !expandedMaxLines ? 'line-clamp-none' : 'line-clamp-2',
          className
        )}
      >
        {text}
      </span>
      {isOverflowing && (
        <Button
          color='neutral'
          variant='ghost'
          size='1'
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            toggleExpanded();
          }}
          className='-ml-fly-3'
        >
          {isExpanded ? 'Read less' : 'Read more'}
        </Button>
      )}
    </div>
  );
}
